import React, { useState, useEffect } from 'react'
import { Table as UxTable, Form } from '@deere/ux.uxframe-react'
import CustomAlert from '../components/CustomAlert';
import { SCBM_SECCIO_CODES, PERCENTAGE_ARRAY, PERCENTAGE_ARRAY_FL, MARKET_SEGMENT, DEERE_DEMAND } from '../utils/surveyLiterals'
import { findAnswerIndex, getTranslation } from '../utils/utils';
import { useTranslation } from "react-i18next";
import { useDispatch } from 'react-redux';
import { setBusinessTotal } from '../redux/action/surveyAction';

export default function Table({ section, questions, updateAnswer, answers, checkedProprietary, isTotal}) {
    const questionTitle = questions ? questions.find(q => q.type === 'OPEN_TITLE') : null;
    const listQuestions = questions ? questions.filter(q => q.type === 'TABLE_BS') : null;
    const questionFormula = questions ? questions.find(q => q.type === 'FORMULA') : null;
    const marketSegHeader = questions ? questions.find(q => q.type === MARKET_SEGMENT) : null;
    const deereDemandHeader = questions ? questions.find(q => q.type === DEERE_DEMAND) : null;
    const colNames = listQuestions && Array.isArray(listQuestions) && listQuestions[0] && listQuestions[0].dependentQuestions ? listQuestions[0].dependentQuestions.map(q => getTranslation(q, 'text')) : [];

    const questionWarn = questions ? questions.find(q => q.type === 'BS_WARN') : null;
    const [total, setTotal] = useState(0)
    const [totalMap] = useState(new Map([]))
    const [displayAlert, setDisplayAlert] = useState(false)
    const { t } = useTranslation();
    const dispatch = useDispatch()

    useEffect(() => {
        getTotal()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [answers])

    const businessTotalField = <tr>
        <td className='p-1'>{t('bs_total')}</td>
        <td className="text-center">{total}%</td>
        <td className='p-1'></td>
    </tr>


    function getTotal() {
        listQuestions && listQuestions.map((data, index) =>
            data.dependentQuestions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).forEach(dq => {
                if (dq.type === 'PERC_SALES') {
                    let key = `uxf-tselect-${index}`
                    let qidx = findAnswerIndex(dq.id, answers);
                    let value = (qidx >= 0) ? parseFloat(answers[qidx].answer) : 0;
                    totalMap.set(key, value)
                }
            }
            )
        )
        calculateTotal();
    }


    function calculateTotal() {
        let sumTotal = 0;
        totalMap.forEach((value) => {
            const percentage = parseFloat(value)
            if(!Number.isNaN(percentage))
                sumTotal = sumTotal + percentage
        });
        setTotal(sumTotal)
        dispatch(setBusinessTotal(sumTotal))
        if (sumTotal !== 100) {
            setDisplayAlert(true)
        }
        else {
            setDisplayAlert(false)
        }
    }


    const handlePercentageChange = (e, key, question) => {
        if (totalMap.has(key)) {
            const oldValue = totalMap.get(key)
            const newValue = e.target.value ? e.target.value : '0';
            if (oldValue !== newValue) {
                totalMap.delete(key);
                totalMap.set(key, newValue)
            }
        }
        else {
            totalMap.set(key, e.target.value)
        }
        calculateTotal();
        updateAnswer(e, question.id)
    }
    function createRadioGroup(selections, question) {
        let qidx = findAnswerIndex(question.id, answers);
        return <>
            {selections.sort((a, b) => (a.value > b.value) ? 1 : -1).map(sel =>
                <Form.Check
                    required={!checkedProprietary}
                    type="radio"
                    inline
                    label={getTranslation(sel, 'text')}
                    name={`${getTranslation(section, 'description')}-${question.id}`}
                    value={sel.value}
                    id={sel.id}
                    key={sel.id}
                    onChange={(e) => updateAnswer(e, question.id)}
                    checked={qidx >= 0 && answers[qidx].answer === sel.value}
                />)}
        </>

    }

    function createCombo(options, question, index) {
        let qidx = findAnswerIndex(question.id, answers);
        return (
            <Form.Control required={!checkedProprietary} name={`${getTranslation(section, 'description')}-select`} as="select" className="custom-select"
                value={qidx >= 0 ? answers[qidx].answer : ''}
                onChange={e => handlePercentageChange(e, `uxf-tselect-${index}`, question)}
            >
                {options ? options.map(opt => <option key={opt} value={opt}>{opt} %</option>) : null}
            </Form.Control>
        )
    }
    function createComboFL(options, question, index) {
        let qidx = findAnswerIndex(question.id, answers);
        return (
            <Form.Control required={!checkedProprietary} name={`${getTranslation(section, 'description')}-select`} as="select" className="custom-select"
                value={qidx >= 0 ? answers[qidx].answer : ''}
                onChange={e => handlePercentageChange(e, `uxf-tselect-${index}`, question)}
            >
                 <option value = "">Select</option>
                {options ? options.map(opt => <option key={opt} value={opt}>{opt} </option>) : null}
            </Form.Control>
        )
    }
    function createRow(question, index) {
        return <tr key={index}>
            <td className='p-1'>{getTranslation(question, 'text')}</td>
            {
                question.dependentQuestions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1)
                .map(dq =>
                    <td key={dq.id}>
                        {dq.type === 'PERC_SALES' ? createCombo(PERCENTAGE_ARRAY, dq, index) : <></>}
                        {dq.type === 'OPTION' ? createRadioGroup(dq.selections, dq) : <></>}
                    </td>
                )

            }
        </tr>
    } 


    function createRowFL(question, index) {
        return <tr key={index}>
            <td className='p-1'>{getTranslation(question, 'text')}</td>
            {
                question.dependentQuestions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map(dq =>
                    <td key={dq.id}>
                        {dq.type === 'PERC_SALES' ? createComboFL(PERCENTAGE_ARRAY_FL, dq, index) : <></>}
                        {dq.type === 'OPTION' ? createRadioGroup(dq.selections, dq) : <></>}
                    </td>
                )

            }
        </tr>
    } 
    return (
        <>
            {listQuestions && listQuestions.length > 0 &&
            <UxTable striped hover size="sm" >
            <caption>{getTranslation(questionFormula, 'text')}</caption>
                <caption>{getTranslation(questionTitle, 'text')}</caption>
                <thead>
                    <tr>
                        {section && section.code === SCBM_SECCIO_CODES.BS ? (
                            marketSegHeader ? (
                            <th className="p-1" scope="col">{getTranslation(marketSegHeader, "text")}</th>
                            ) : (
                            <th className="p-1" scope="col"></th>
                            )
                        ) : section && section.code === SCBM_SECCIO_CODES.FL ? (
                            deereDemandHeader ? (
                            <th className="p-1" scope="col">{getTranslation(deereDemandHeader, "text")}</th>
                            ) : (
                            <th className="p-1" scope="col"></th>
                            )
                        ) : (
                            <th className="p-1" scope="col"></th>
                        )}
                        {
                            colNames ? colNames.map(qt =>
                                <th scope="col" className="p-1 text-center" key={qt}>{qt}</th>) : <></>

                        }
                    </tr>
                </thead>
                <tbody>
                    {
                       (section && section.code === SCBM_SECCIO_CODES.BS) ?
                      listQuestions && listQuestions.map((data, index) => createRow(data, index))
                      : ((section && section.code === SCBM_SECCIO_CODES.FL) ? 
                      listQuestions && listQuestions.map((data, index) => createRowFL(data, index))
                      :listQuestions && listQuestions.map((data, index) => createRow(data, index))
                    )
                    }
                    {
                        (isTotal && section && section.code === SCBM_SECCIO_CODES.BS) ? businessTotalField : null
                    }
                </tbody>
            </UxTable>
            }
            {
               section && section.code === SCBM_SECCIO_CODES.BS
                 ? 
                    <div style={{display:'flex', justifyContent:'flex-end', margin: '0px 0px 10px 0px'}}>
                        <h6>{t('scbm_bs_table_total')} </h6>
                    </div>
                 :
                    null
            }
            {
                (isTotal && displayAlert && section && section.code === SCBM_SECCIO_CODES.BS) ? <CustomAlert accessibilityLabel='Warning:' variant='warning' title={getTranslation(questionWarn, 'text')} id={checkedProprietary?'NoVal':'bsTotal'} name={getTranslation(section, 'description')}/> : null
            }
        </>
    )
}

